// extracted by mini-css-extract-plugin
module.exports = {"ctaLink":"CtaLink_ctaLink__Yghbc","lightColor":"CtaLink_lightColor___BMXA"};